import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import { Box, Button, Typography } from '@mui/material';
import strings from 'common/Translation/Translate';
import { images } from 'utils/constants/images';
import { useCustomNavigate } from 'utils/hooks/useCustomNavigate';
const PageNotFound = () => {
  const navigate = useCustomNavigate();
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'primary',
        // background: theme.palette.primary.main,
        // color: theme.palette.primary.contrastText,
        flexDirection: 'column',
      }}>
      <img width="50%" src={images.pageNotFound} alt="page not found" />
      <Typography fontSize={{ xs: 20, md: 40 }}>Opps! Page not found</Typography>
      <Typography fontSize={{ xs: 12, md: 16 }} my={2}>
        {strings.page_not_found_desc_text}
      </Typography>
      <Button
        data-testid={'button'}
        sx={{
          mt: 2,
          background: '#013556',
          fontWeight: 'bold',
          color: '#fff',
          '&:hover': { background: '#013556', color: '#fff', opacity: 0.9 },
        }}
        variant="contained"
        onClick={() => navigate('/')}>
        <HomeRoundedIcon sx={{ mr: 1 }} />
        {strings.error_page_back_home_text}
      </Button>
    </Box>
  );
};

export default PageNotFound;
